export default class Language {
  constructor(element) {
    this.element = element;

    this.currentUrl = window.location.href;

    this.checkForErrorPage();
    this.init();
  }

  init() {
    this.element
      .querySelector('.lang__toggle')
      .addEventListener('click', this.setPath.bind(this));
  }

  setPath(event) {
    event.preventDefault();

    if (this.currentUrl.includes('/en/')) {
      let frenchUrl = this.currentUrl.replace('/en/', '/');
      window.location.href = frenchUrl;
    } else {
      let englishUrl = this.currentUrl.replace(
        window.location.origin + '/',
        window.location.origin + '/en/'
      );
      window.location.href = englishUrl;
    }
  }

  checkForErrorPage() {
    console.log(document.title);

    // Vérifiez si l'URL actuelle correspond à une page d'erreur dans la version anglaise
    const isEnglish404Page =
      this.currentUrl.includes('/en/') && document.title.includes('404');

    if (isEnglish404Page) {
      // Redirige vers la page 404 à la racine
      window.location.href = `${window.location.origin}/404.shtml`;
    }
  }
}
